module.exports = __webpack_public_path__ + "media/images/icon__reddit@2x-1e3ba4f7492b3e88114ccea21c838c44.png";